import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { ROUTES } from '../constants/routes';

/**
 * PublicRoute component
 * Wrapper for routes that should only be accessible when NOT authenticated
 * (e.g., login, register pages)
 * Redirects to dashboard if user is already authenticated
 */
export const PublicRoute: React.FC = () => {
  const { userData, isLoading } = useAuth();

  // Show loading state while checking auth
  if (isLoading) {
    return (
      <div className="fullpage-loading">
        <div className="fullpage-loading-spinner"></div>
        <div className="fullpage-loading-text">Loading...</div>
      </div>
    );
  }

  // Check if user is authenticated
  const isAuthenticated = userData.userAddress !== null || userData.isAdmin !== null;

  // Redirect to dashboard if already authenticated
  if (isAuthenticated) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  // Render child routes
  return <Outlet />;
};
